import { call, put, takeEvery } from "redux-saga/effects";

import { manualSubscriptionSuccess, manualSubscriptionError } from "./actions";
import { MANUAL_SUBSCRIPTION, ManualSubscriptionAction } from "./actionTypes";
import { manualSubscription } from "../../helpers/backend_helper";

function* manualSubscriptionSaga({
  payload: { request },
}: ManualSubscriptionAction) {
  try {
    yield call(manualSubscription, request);
    yield put(manualSubscriptionSuccess());
  } catch (error) {
    yield put(manualSubscriptionError(error));
  }
}

function* SubscriptionSaga() {
  yield takeEvery(MANUAL_SUBSCRIPTION, manualSubscriptionSaga);
}

export default SubscriptionSaga;
